import { TransferAppAction, TransferAppEndAction } from "./TransferApp";

export * from "./ErrorAction";
export * from "./TransferApp";

export type AdminActions = TransferAppAction | TransferAppEndAction;
